import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';

// !!!
const GridRow = props => {
  const classNames = getClassNames('llm__row');
  return jsx("div", {
    className: classNames,
    children: props.children
  });
};
const Grid = props => {
  const columns = Object.fromEntries(['xs', 'sm', 'md', 'lg', 'xl'].filter(x => {
    return props[x] != null;
  }).map(x => {
    return [`--${x}-${props[x]}`, true];
  }));
  const classNames = getClassNames('llm__col', columns);
  return jsx("div", {
    className: classNames,
    children: props.children
  });
};

export { Grid, GridRow };
//# sourceMappingURL=grid.js.map
